module.exports = __webpack_public_path__ + "img/noPrize.8b9b761e.png";